var $7743e79780ebcca3$exports = {};
$7743e79780ebcca3$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Vrijednost mora biti ".concat(args.maxValue, " ili ranije.");
  },
  "rangeReversed": "Datum po\u010Detka mora biti prije datuma zavr\u0161etka.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Vrijednost mora biti ".concat(args.minValue, " ili kasnije.");
  },
  "unavailableDate": "Odabrani datum nije dostupan."
};
export { $7743e79780ebcca3$exports as default };